import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type UiTagColor = 'primary' | 'warning' | 'success' | 'info' | 'neutral' | 'danger';
export type UiTagAppearance = 'filled' | 'outline';

/**
 * Átomo: etiqueta de categoría compacta (badge/chip).
 * Solo presentación; sin lógica ni outputs.
 */
@Component({
  selector: 'ui-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
  host: {
    class: 'ui-tag-host',
    '[class]': 'hostClass()',
  },
})
export class UiTagComponent {
  readonly label = input.required<string>();
  readonly color = input<UiTagColor>('neutral');
  readonly appearance = input<UiTagAppearance>('filled');
  /** Elipsis de una línea cuando el padre limita el ancho. */
  readonly truncate = input(false);

  protected readonly hostClass = computed(
    () =>
      `ui-tag-host ui-tag-host--${this.color()} ui-tag-host--${this.appearance()}${this.truncate() ? ' ui-tag-host--truncate' : ''}`,
  );
}
